<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body">
						<div class="DateSelect flex">
							<label style="margin-left: 0px; margin-top: 0px; margin-bottom: 0px">Start Date:</label>

							<div style="width: fit-content; margin-left: 10px; margin-top: 0px; margin-bottom: 0px">
								<p-calendar
									[(ngModel)]="StartDate"
									(ngModelChange)="onStartDateChange($event)"
									showIcon="true"
									showButtonBar="true"
								></p-calendar>
							</div>

							<label style="margin-left: 10px; margin-top: 0px; margin-bottom: 0px">End Date:</label>

							<div style="width: fit-content; margin-left: 10px; margin-top: 0px; margin-bottom: 0px">
								<p-calendar [(ngModel)]="EndDate" (ngModelChange)="onEndDateChange($event)" showIcon="true" showButtonBar="true"></p-calendar>
							</div>
						</div>

						<div class="flex">
							<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

							<!--INSERT CUSTOM BUTTONS HERE-->
							<button class="btn btn-primary" style="margin-left: 5px" (click)="onViewDetails()">View Details</button>
							<!-- <button class="btn btn-primary" style="margin-left:5px;" (click)="onPrint()">Print</button> -->
						</div>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstScan"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedScan"
						dataKey="ScanID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--PersonName-->
								<th>
									<p-columnFilter type="text" field="PersonName" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--ScanDT-->
								<th>
									<!-- <p-columnFilter type="text" field="ScanDTDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--StationModeDesc-->
								<th>
									<p-columnFilter field="StationModeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterStationModeDesc
												[ngModel]="value"
												[options]="lstStationModeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ResultDesc-->
								<th>
									<p-columnFilter field="ResultDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterResultDesc
												[ngModel]="value"
												[options]="lstResultDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ScanStation-->
								<th>
									<p-columnFilter field="ScanStation" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterScanStation
												[ngModel]="value"
												[options]="lstScanStation"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ManualDesc-->
								<th>
									<p-columnFilter field="ManualDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterManualDesc
												[ngModel]="value"
												[options]="lstManualDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--Facility Name-->
								<th>
									<p-columnFilter field="FacilityName" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterFacilityName
												[ngModel]="value"
												[options]="lstFacilityName"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--Facility Location Name-->
								<th>
									<p-columnFilter field="FacilityLocationName" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterFacilityLocationName
												[ngModel]="value"
												[options]="lstFacilityLocationName"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--Has Reminder Desc-->
								<th>
									<p-columnFilter field="HasReminderDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterHasReminderDesc
												[ngModel]="value"
												[options]="lstHasReminderDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="PersonName">Name<p-sortIcon field="PersonName"></p-sortIcon></th>
								<th pSortableColumn="ScanDTDesc">Date<p-sortIcon field="ScanDTDesc"></p-sortIcon></th>
								<th pSortableColumn="StationModeDesc">Station Mode<p-sortIcon field="StationModeDesc"></p-sortIcon></th>
								<th pSortableColumn="ResultDesc">Scan Result<p-sortIcon field="ResultDesc"></p-sortIcon></th>
								<th pSortableColumn="ScanStation">ScanStation<p-sortIcon field="ScanStation"></p-sortIcon></th>
								<th pSortableColumn="ManualDesc">Manual<p-sortIcon field="ManualDesc"></p-sortIcon></th>
								<th pSortableColumn="FacilityName">Facility<p-sortIcon field="FacilityName"></p-sortIcon></th>
								<th pSortableColumn="FacilityLocationName">Location<p-sortIcon field="FacilityLocationName"></p-sortIcon></th>
								<th pSortableColumn="HasReminderDesc">Has Reminder<p-sortIcon field="HasReminderDesc"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-Scan>
							<tr [pSelectableRow]="Scan" (dblclick)="onRowDblClick(Scan)">
								<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
									{{ Scan[col.field] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="SelectedScan?.HasReminder == true">
	<caass-staff-scan-history-reminders [SelectedEntry]="SelectedScan"> </caass-staff-scan-history-reminders>
</div>
